module.exports = __webpack_public_path__ + "img/20190814161014307.c0f24dfb.png";